var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowsFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5 3.5h7.192v7.188H3.5V3.5Zm9.808 0H20.5v7.188h-7.192V3.5ZM3.5 13.308h7.192V20.5H3.5v-7.192Zm9.808 0H20.5V20.5h-7.192"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsFill);
export default __webpack_public_path__ + "static/media/windows_fill.4d18418baf0321bf4971e7939908f0f2.svg";
export { ForwardRef as ReactComponent };